// Tryb — the facilitator conduct code.
//
// PLACEHOLDER COPY. Written in the product's voice so the flow can be read and
// tested end to end, but it has not been through legal. Replace `SECTIONS`
// with the approved text before launch and bump `VERSION` when you do — the
// version is recorded against the facilitator's acceptance.

export const CONDUCT_CODE = {
  version: "1.2",
  updated: "August 2026",

  // The one-line version, shown next to the toggle for anyone who won't open it.
  summary: "Learn names, keep the room kind, and nobody sits alone at The After.",

  intro:
    "You're not signing a contract. This is the short list of things every tryb host agrees to, because a stranger booking a seat needs to know what they're walking into. It takes two minutes to read.",

  sections: [
    {
      id: "room",
      title: "The room",
      points: [
        "Learn people's names in the first two weeks, and use them. It is the single thing that turns eight strangers into a group.",
        "Start when you said you'd start. A host who runs late teaches the room that turning up on time doesn't matter.",
        "Nobody gets left standing on their own. If someone is on the edge of the group, that's yours to fix, not theirs.",
        "Beginners are the point. Never let the room make someone feel slow, unfit or behind.",
      ],
    },
    {
      id: "after",
      title: "The After",
      points: [
        "If you said there's an After, turn up to it. It's where the actual talking happens.",
        "Say clearly what it costs and whether people pay their own way, before anyone books.",
        "Walk with people to the venue rather than pointing at it. First-timers won't follow directions to a table of strangers.",
        "Nobody is made to drink, and nobody is made to explain why they aren't.",
      ],
    },
    {
      id: "safety",
      title: "Safety",
      points: [
        "You are responsible for the space while the session runs: the route in, the lighting, the exits, the floor.",
        "Tell people beforehand about anything physical, anything that involves being touched, and anything that finishes after dark.",
        "Never share an attendee's number, address or anything they told you in confidence.",
        "If something goes wrong — an injury, an incident, someone behaving badly — you tell tryb the same day. We would always rather hear it from you.",
      ],
    },
    {
      id: "photos",
      title: "Photos and posting",
      points: [
        "Faces go online only with that person's explicit yes, asked for on the night rather than assumed at booking.",
        "One no means the camera goes away. You don't ask twice and you don't work around it.",
        "Never use a photo of your group to sell something that isn't the tryb.",
      ],
    },
    {
      id: "money",
      title: "Money",
      points: [
        "The price on the listing is the price. No surprise costs on the night.",
        "Honour the cancellation and refund terms you published, including when it's inconvenient.",
        "Don't take payment off-platform. It removes every protection the member booked with.",
      ],
    },
    {
      id: "honesty",
      title: "Honesty",
      points: [
        "Describe the session that actually happens, not the one you'd like to be running.",
        "If you can't make a night, say so early and offer a substitute or a refund. Silence is the one unforgivable thing.",
        "Don't run the same people through a 'beginners' season twice to keep numbers up.",
      ],
    },
  ],

  closing:
    "Break any of this and we'll talk to you first — once. Break the safety or photo rules and your listings come down the same day.",
};
